import { useCallback } from 'react'
import styled from 'styled-components'

import { useAuthContext } from '../../../Authentication/hooks/useAuthContext'
import { Button } from '../../../UI/Button'
import { PasswordField } from './PasswordField'
import { useForm } from './useForm'

const Styles = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    max-width: 280px;
`

export const UpdatePasswordForm = () => {
    const { user } = useAuthContext().user
    const formHookState = useForm(user?._id, user?.email)
    const { form, isLoading, createPassword } = formHookState

    const isDisabled =
        !form.newPassword.value ||
        Boolean(form.newPassword.error) ||
        !form.confirmNewPassword.value ||
        Boolean(form.confirmNewPassword.error)

    const onSubmit = useCallback(() => {
        if (!isDisabled) {
            createPassword()
        }
    }, [createPassword, isDisabled])

    return (
        <Styles>
            <PasswordField
                className="mt-5"
                label="New password"
                field="newPassword"
                formHookState={formHookState}
                showPasswordStrength={true}
            />
            <PasswordField
                className="mt-5"
                label="Confirm new password"
                field="confirmNewPassword"
                formHookState={formHookState}
            />
            <Button
                className="mt-6 self-start"
                intent="text"
                label="Create"
                onClick={onSubmit}
                isLoading={isLoading}
                disabled={isDisabled}
            />
        </Styles>
    )
}
